import { useEffect } from 'react'

/**
 * Hook to listen for the Enter key and trigger a callback.
 * Useful for submitting forms/dialogs without wrapping in <form> tags.
 */
export const useEnterSubmit = (onEnter: () => void, enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        const target = event.target as HTMLElement

        // Skip if the user is typing in a textarea, button, or contenteditable element (e.g. Quill editor)
        if (
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'BUTTON' ||
          target.getAttribute('contenteditable') === 'true' ||
          target.closest('[contenteditable="true"]')
        ) return

        // Skip if target is inside a mentionable or search input that handles Enter differently
        // (optional, but good for UX)
        if (target.closest('[data-enter-ignore="true"]')) return

        event.preventDefault()
        onEnter()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [onEnter, enabled])
}
